import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-210266f4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "progress-view"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "记者处理进展", -1));

const _hoisted_3 = {
  class: "user-wrap"
};
const _hoisted_4 = {
  class: "head-wrap"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "name"
};
const _hoisted_7 = {
  class: "text-wrap"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));

import { ref, computed } from 'vue';
import request from '@/api';
import { arrangeDate } from '@/utils/regular';
import NewsCell from '@/components/common/news-cell.vue';
export default {
  props: {
    postItem: Object
  },

  setup(__props) {
    const props = __props;
    const progressList = ref(0);
    const news = ref(0);

    if (props.postItem.type == 'REPORT') {
      // 找记者
      request.getProgressById(props.postItem.id).then(res => {
        progressList.value = res.data.progressList;
        news.value = res.data.news;
      });
    }

    const publishTime = computed(() => {
      return value => {
        return arrangeDate(value);
      };
    });
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");

      return _openBlock(), _createElementBlock(_Fragment, null, [progressList.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(progressList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "cell",
          key: 'progress' + index
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_van_image, {
          class: "head",
          src: item.photoImg,
          alt: ""
        }, null, 8, ["src"]), item.authenticationIcon && item.authenticationIcon.length > 0 ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "author-icon",
          src: item.authenticationIcon,
          alt: ""
        }, null, 8, _hoisted_5)) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_6, [_createTextVNode(_toDisplayString(item.nickName), 1), _createElementVNode("span", null, _toDisplayString(_unref(publishTime)(item.createTime)), 1)])]), _createElementVNode("p", _hoisted_7, _toDisplayString(item.content), 1)]);
      }), 128)), _hoisted_8])) : _createCommentVNode("", true), news.value && news.value.newsId ? (_openBlock(), _createBlock(NewsCell, {
        key: 1,
        news: news.value
      }, null, 8, ["news"])) : _createCommentVNode("", true)], 64);
    };
  }

};